import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ServicesService } from '../../services/services.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';



@Component({
  selector: 'app-delivery-information',
  templateUrl: './delivery-information.component.html',
  styleUrls: ['./delivery-information.component.css']
})
export class DeliveryInformationComponent implements OnInit {
  apiUrl;
  cid: any;
  did: any;
  lid: any;
  clientData: any;
  backDiv: any = false;
  cname: any;
  role_id;
  button_disable = false;
  employeeList;
  deliveryEmp;
  routePath1;
  contact: any;
  completed = false;
  loadsheetUpdateForm: FormGroup;
  routePath: any;
  deliveryData: any;
  orderList: any;
  spinLoader = {
    pageLoaded: false,
    delete: []
  };
  editRowId: any;
  delivery_arr = [];
  updated_id;
  delivery_status;

  constructor(private route: ActivatedRoute, private router: Router, private _services: ServicesService, private formBuilder: FormBuilder) {
    this.route.queryParams.subscribe(params => {
      //console.log(params);
      this.cid = params['cid'];
      this.cname = params['cname'];
      this.did = params['did'];
      this.lid = params['lid'];
    });
  }

  ngOnInit() {
    const userData = JSON.parse(localStorage.getItem('userData'));
    this.role_id = userData.role_id;
    this.Show();

    this.loadsheetUpdateForm = this.formBuilder.group({
      employee: ['', Validators.required],
      delivery_address: ['', Validators.required],
      client_delivery_to: ['', Validators.required],
      delivery_date: ['', Validators.required],
      delivery_note: ['', Validators.required],
      vehicle_reg_no: ['', Validators.required],
      delivery_handle_by: ['', Validators.required],
      contact_person_name: ['', Validators.required],
      contact_person_mobile_no: ['', Validators.required],
      delivery_id: ['']

    });

    if (this.cid != undefined) {
      this.backDiv = true;
    } else {
      this.backDiv = false;
    }

    if (this.did != '') {
      this.showDeliveryInfo(this.did, this.cid, this.lid);
    }

    this.apiUrl = environment.apiUrl;
  }

  refreshPage(): void {
    if (this.did != '') {
      this.showDeliveryInfo(this.did, this.cid, this.lid);
    }
  }

  updateD(){
    this.updateLoadsheetEmp()
    this.updateDelivery()
  }

  updateLoadsheetEmp() {
    if (this.loadsheetUpdateForm.status === 'INVALID') {
      swal({
        title: 'warning',
        text: 'Please fill the required  field',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: 'rgb(17, 205, 239)',
        cancelButtonColor: 'rgb(245, 54, 92)',
        confirmButtonText: 'ok'
      });
      return;
    }
    this.routePath1 = 'update-delivery-info';
    const token = this._services.getToken();
    this.button_disable = true;
    this._services.postRequest(this.loadsheetUpdateForm.value, this.routePath1, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        swal({
          title: 'Delivery',
          text: 'Delivery Updated Successfully',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        });
        // this.employeeList = data.result;
        this.button_disable = false;
      }
    }
    );
  }

  updateDeliveryEle(value) {

    if (this.delivery_arr.indexOf(value) < 0) {
      this.delivery_arr.push(value);
    } else {
      this.delivery_arr = this.delivery_arr.filter((ele: any) => {
        return value.value.component_id !== ele.value.component_id;
      });
      this.delivery_arr.push(value);
    }


  }

  updateDelivery() {
    const routeData = 'Update_delivery';
    const token = this._services.getToken();
    const data = {
      delivery_id: this.updated_id,
      arr: this.delivery_arr
    };

    this._services.postRequest(data, routeData, token).subscribe((resp: any) => {

    });
  }

  Show() {
    this.routePath = 'get-employee-names';
    const token = this._services.getToken();
    const data = {

    };
    this._services.postRequest(data, this.routePath, token).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.employeeList = data.result;
      }
    }
    );
  }

  showDeliveryInfo(did, cid, lid) {
    this.spinLoader['pageLoaded'] = true;
    this.routePath = 'get-delivery-info';
    const token = this._services.getToken();
    let data = {
      delivery_id: did,
      client_id: cid,
      loadsheet_id: lid,
    };
    this._services.postRequest(data, this.routePath, token).subscribe((data: any) => {
      if (this._services.checkToken('status')) {
        this.spinLoader['pageLoaded'] = false;
        for (const element in data.result.client) {
          this.clientData = data.result.client[element];
        }
        for (const element in data.result.delivery) {
          this.deliveryData = data.result.delivery[element];
        }
        this.deliveryData.image_1 = environment.imageUrl + this.deliveryData.image_1;
        this.deliveryData.image_2 = environment.imageUrl + this.deliveryData.image_2;
        this.deliveryData.image_3 = environment.imageUrl + this.deliveryData.image_3;
        this.deliveryData.emp_sign = environment.imageUrl + this.deliveryData.emp_sign;
        this.deliveryData.driver_sign = environment.imageUrl + this.deliveryData.driver_sign;
        this.deliveryData.cont_sign = environment.imageUrl + this.deliveryData.cont_sign;
        this.deliveryEmp = this.deliveryData.user_id;
        this.delivery_status = data.result.delivery[0].delivery_status;
        this.updated_id = data.result.delivery[0].id;

        // //console.log(this.contact);


        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({employee:  this.deliveryEmp});
        // this.loadsheetUpdateForm.patchValue({delivery_id: this.did});
        //console.log(this.deliveryData);
        this.loadsheetUpdateForm.patchValue(
          {
            employee: this.deliveryEmp,
            delivery_id: this.did,
            delivery_address: this.deliveryData.delivery_address,
            client_delivery_to: this.clientData.client_name,
            delivery_date: this.deliveryData.delivery_date,
            delivery_note: this.deliveryData.delivery_note,
            vehicle_reg_no: this.deliveryData.vehicle_reg_no,
            contact_person_name: this.deliveryData.contact_person_name,
            contact_person_mobile_no: this.deliveryData.contact_person_mobile,
            delivery_handle_by: this.deliveryData.transport_company
          }
        );
        this.orderList = [];
        this.orderList = data.result.orders;
        if ((this.deliveryData.driver_name == null || this.deliveryData.driver_name == '') && (this.deliveryData.emp_name == null || this.deliveryData.emp_name == '')) {
          this.completed = true;
        }
        //console.log("this.deliveryData", this.deliveryData, this.orderList)
      }
    });
  }




  toggle(id) {
    this.editRowId = id;

  }




}
